module.exports = __webpack_public_path__ + "static/media/ConnectCircle.150e00ea.svg";